//页面通讯 vue.$on(key) vue.$emit(key)
const prefix = "cesyd_";//前缀
const communicate = {
	paySuccess: create('PAY_SUCCESS'), //支付成功
	enrollPayStatus: create('ENROLL_PAY_STATUS'), //报名服务费状态刷新
	admissionInformation: create("EDIT_DEPUTATION"),//赛事和培训的报名须知
}
function create(key){
	key = prefix + key;
	return {
		$on(callback){
			window.$vm.$on(key, callback);
			return this;
		},
		$off(){
			window.$vm.$off(key);
			return this;
		},
		$emit(...arg){
			window.$vm.$emit(key, ...arg);
			return this;
		}
	}
}
export default communicate;